import { fetchSameOrigin } from '../Utils';
import { get } from 'lodash';
import moment from 'moment';
import queryString from 'query-string';

function setSearchParam(url, attribute, name) {
  if(attribute){
    url.searchParams.append(name, attribute)
  }
}
const openReg = (params, beta=false) => {
  if(beta){
    const url = new URL(`${"http://"}replace.me/members/register_impersonate`);
    setSearchParam(url, params.firstName, "member_data[first_name]");
    setSearchParam(url, params.lastName, "member_data[last_name]");
    setSearchParam(url, moment(params.dob).format("MM/DD/YYYY"), "member_data[dob]");
    setSearchParam(url, params.zipCode, "member_data[zip_code]");
    setSearchParam(url, params.promoCode, "member_data[promo_code]");
    setSearchParam(url, params.email, "member_data[email]");
    setSearchParam(url, params.gender, "member_data[gender]");
    setSearchParam(url, params.benefitToken, "member_data[benefit_token]")
    return fetchSameOrigin(url.href.slice(url.origin.length), 'POST')
      .then(r => r.json()).then( ({ impersonation_url })=> {
        return new Promise((resolve, reject) => {
          window.open(impersonation_url);
          resolve();
        });
      })
  }else{
    if(params.groupName){
      return new Promise((resolve, reject) => {
        window.open(`/registrations/new?${queryString.stringify({group_nm: params.groupName})}`)
        resolve();
      });
    }else{
      const param = {
        //is_primary_member
        'registration[member_id]': params.memberId,
        'registration[first_nm]': params.firstName,
        'registration[last_nm]': params.lastName,
        'registration[dob]': moment(params.dob).format("MM/DD/YYYY"),
        'registration[source_member_id]': params.hpid,
      }
      if(params.regGroupCode){
        param['registration[registration_group_cd'] = params.regGroupCode;
      }else{
        param['registration[vendor]'] = `REGTYPE_RTE${params.vendor}`;
      }
      return new Promise((resolve, reject) => {
        window.open(`/registrations/preregister?${queryString.stringify(param)}`)
        resolve();
      });
    }
  }
}

export default openReg;

window.openReg = openReg;
